import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import asyncReducer from '../common/reduxs/async/asyncReducer';
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
// import storage from 'redux-persist/lib/storage';
import modalReducer from '../modals/redux/modalReducer';
import sessionStateReducer from '../common/reduxs/session/reduxReducer';
import authReducer from '../login/redux/authReducer';
import { reducer as formReducer } from 'redux-form';
import menusReducer from '../common/reduxs/menu/menusReducer';
import dashboardReducer from '../../menus/dashboard/redux/reduxReducer';
import userReducer from '../../menus/users/redux/reduxReducer';
import roleReducer from '../../menus/roles/redux/reduxReducer';
import searchFormReducer from '../common/reduxs/search/reduxReducer';
import rppReducer from '../../menus/_features/rpp/redux/reduxReducer';
import materiReducer from '../../menus/_features/materi/redux/reduxReducer';
import tugasReducer from '../../menus/_features/tugas/redux/reduxReducer';
import latihanReducer from '../../menus/_features/latihan/redux/reduxReducer';
import tesReducer from '../../menus/_features/tes/redux/reduxReducer';
import monitoringReducer from '../../menus/_features/monitoring/redux/reduxReducer';
import cbtparticipantReducer from '../../menus/_features/cbt/participant/redux/reduxReducer';
import cbtquestionReducer from '../../menus/_features/cbt/question/redux/reduxReducer';
import rombelReducer from '../../menus/_features/rombel/redux/reduxReducer';
import studentReducer from '../../menus/_features/student/redux/reduxReducer';
import jadwalReducer from '../../menus/_features/jadwal/redux/reduxReducer';
import absenceReducer from '../../menus/_features/absence/redux/reduxReducer';
import activityReducer from '../../menus/_features/activity/redux/reduxReducer';
import noteReducer from '../../menus/_features/notes/redux/reduxReducer';
import whatsappReducer from '../../menus/_features/whatsapp/redux/reduxReducer';
import pesanpribadiReducer from '../../menus/_features/pesanpribadi/redux/reduxReducer';
import slideshowReducer from '../../menus/_features/slideshow/redux/reduxReducer';
import announcementReducer from '../../menus/_features/announcement/redux/reduxReducer';
import calendarReducer from '../../menus/_features/calendar/redux/reduxReducer';
import portaluserReducer from '../../menus/_features/portaluser/redux/reduxReducer';
import jenjangReducer from '../../menus/_features/jenjang/redux/reduxReducer';
import tingkatReducer from '../../menus/_features/tingkat/redux/reduxReducer';
import kelasReducer from '../../menus/_features/kelas/redux/reduxReducer';
import pelajaranReducer from '../../menus/_features/pelajaran/redux/reduxReducer';
import guruReducer from '../../menus/_features/guru/redux/reduxReducer';
import yearReducer from '../../menus/_features/year/redux/reduxReducer';
import semReducer from '../../menus/_features/sem/redux/reduxReducer';
import settingReducer from '../../menus/_features/setting/redux/reduxReducer';
// Website
import categoryReducer from '../../menus/_website/category/redux/reduxReducer';
import menuwebReducer from '../../menus/_website/menuweb/redux/reduxReducer';
import pageReducer from '../../menus/_website/page/redux/reduxReducer';
import feedbackReducer from '../../menus/_website/feedback/redux/reduxReducer';

const persistConfig = {
  key: 'root',
  // choose storage (local) || storageSession (session)
  storage: storageSession,
};

const appReducer = combineReducers({
  auth: authReducer,
  form: formReducer,
  menus: menusReducer,
  toastr: toastrReducer,
  async: asyncReducer,
  modals: modalReducer,
  sessionState: sessionStateReducer,
  dashboard: dashboardReducer,
  users: userReducer,
  roles: roleReducer,
  searchForm: searchFormReducer,
  rpps: rppReducer,
  materis: materiReducer,
  tugass: tugasReducer,
  latihans: latihanReducer,
  tess: tesReducer,
  monitoring: monitoringReducer,
  cbtparticipants: cbtparticipantReducer,
  cbtquestions: cbtquestionReducer,
  rombels: rombelReducer,
  students: studentReducer,
  jadwals: jadwalReducer,
  absences: absenceReducer,
  activities: activityReducer,
  notes: noteReducer,
  whatsapps: whatsappReducer,
  pesanpribadis: pesanpribadiReducer,
  slideshows: slideshowReducer,
  announcements: announcementReducer,
  calendars: calendarReducer,
  portalusers: portaluserReducer,
  jenjangs: jenjangReducer,
  tingkats: tingkatReducer,
  kelass: kelasReducer,
  pelajarans: pelajaranReducer,
  gurus: guruReducer,
  years: yearReducer,
  sems: semReducer,
  setting: settingReducer,
  categories: categoryReducer,
  menuwebs: menuwebReducer,
  pages: pageReducer,
  feedbacks: feedbackReducer,
});

const initialState = appReducer({}, {});

const rootReducer = (state, action) => {
  if (action.type === 'AUTH_LOGOUT') {
    state = initialState;
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
